<template>
  <div style="overflow: auto">
    <div id="main">
      <p style="text-align: center">暂无数据</p>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {organizationTree} from "@/api/organization.js";

require("echarts/theme/macarons");
export default {
  data() {
    return {
      dialogtable: false,
      dialog: false,
      rows: {lidF: ""},
      showimg: false,
      loading: false,
      page: {
        PageIndex: 1,
        PageTotal: 0,
        PageSize: 20,
      },
      column: [
        {
          label: "操作人",
          prop: "realName",
        },
        {
          label: "操作时间",
          prop: "createTime",
        },
        {
          label: "操作类型",
          prop: "type",
          slot: "type",
        },
        {
          label: "操作内容",
          prop: "content",
        },
      ],
      chartData: {},
    };
  },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
    row: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    }
  },
  mounted() {
    this.initChart();
    //是否需要自适应-加了防抖函数
  },
  methods: {
    createEle(title, name) {
      return {
        label: {
          backgroundColor: "#f1f5ff",
          borderRadius: [0, 0, 5, 5],
          formatter: function () {
            const strs2 = name.split("");
            let str2 = "";
            let i = 0, s;
            while (s = strs2[i++]) {
              str2 += s;
              if (!(i % 8)) str2 += "\n";
            }
            return ["{first|" + title + "}", "{second|" + str2 + "}"].join(
              "\n"
            );
          },
          rich: {
            first: {
              backgroundColor: "#2559dc",
              color: "#fff",
              align: "center",
              width: 135,
              height: 25,
              borderRadius: [5, 5, 0, 0],
            },
            second: {
              color: "#000",
              align: "center",
              height: 25,
            },
          },
        },
      };
    },
    createEle1(title, name) {
      return {
        label: {
          backgroundColor: "#f1f5ff",
          borderRadius: [0, 0, 5, 5],
          formatter: function () {
            if (title) {
              const strs = title.split("");
              let str = "";
              let i = 0;
              let s;
              while (s = strs[i++]) {
                str += s;
                if (!(i % 8)) str += "\n";
              }
              const strs2 = name.split("");
              let str2 = "";
              const k = 0;
              let j;
              while (j = strs2[i++]) {
                str2 += j;
                if (!(k % 8)) str2 += "\n";
              }
              return ["{first|" + str + "}", "{second|" + str2 + "}"].join(
                "\n"
              );
            } else {
              return "";
            }
          },
          rich: {
            first: {
              backgroundColor: "#f1f5ff",
              color: "#2559dc",
              align: "center",
              width: 135,
              height: 30,
              borderRadius: 5,
            },
          },
        },
      };
    },
    eachChildren(children) {
      return (
        children?.map((child) => {
          if (child.children) {
            let data = Object.assign(this.createEle(child.type == 1 ? '子公司' : '厂站', child.label), {
              children: [],
            });
            data.children = this.eachChildren(child.children);
            return data;
          } else {
            return this.createEle(child.type == 1 ? '子公司' : '厂站', child.label);
          }
        })
      );
    },
    async initChart() {
      const params = {
        organizationId: this.row.organizationId,
      };
      const _this = this;
      let res = await organizationTree(params);
      _this.chartData = res.data.data[0];
      if (_this.chartData.children) {
        _this.chartData.children.forEach(function (datum, index) {
          index % 2 === 0 && (datum.collapsed = true);
        });
      } else {
        _this.showimg = true;
        return;
      }
      this.chart = echarts.init(document.getElementById("main"), "macarons");
      this.chart.resize();
      let finalData = {};
      finalData = await Object.assign(
        _this.createEle1(_this.chartData.label, _this.chartData.label),
        {
          children: [],
        }
      );
      finalData.children = await _this.eachChildren(_this.chartData.children);
      this.setOptions(finalData);
      let temp = this.chart;
      let container = document.getElementById("main");
      let containerChildCount = temp._chartsViews[0]._data._graphicEls.length;
      const itemHeight = containerChildCount <= 20 ? 120 : 60;
      document.getElementById("main").style.height =
        containerChildCount * itemHeight + "px";
      this.chart.resize();
      this.chart.on("click", function (p) {
        if (p.componentType === "series") {
          if (!p.value) {
            console.log(temp);
            const elesArr = Array.from(
              new Set(temp._chartsViews[0]._data._graphicEls)
            );
            const currentHeight =
              elesArr.length <= 20 ? 120 * elesArr.length : 60 * elesArr.length;
            container.style.height = currentHeight + "px";
            temp.resize();
          }
        }
      });
    },
    setOptions(data) {
      this.chart?.setOption({
        series: [
          {
            zoom: 1, //当前视角的缩放比例
            roam: true, //是否开启平游或缩放
            scaleLimit: {
              //滚轮缩放的极限控制
              min: 0.1,
              max: 10,
            },
            name: "统一授信视图",
            type: "tree",
            orient: "LR", //竖向或水平  TB代表竖向 LR代表水平
            top: "10",
            initialTreeDepth: 10, //树图初始展开的层级（深度）
            expandAndCollapse: true, //点击节点时不收起子节点，default: true
            symbolSize: [135, 65],
            itemStyle: {
              color: "transparent",
              borderWidth: 0,
            },
            lineStyle: {
              color: "#D5D5D5",
              width: 1,
              curveness: 1,
            },
            data: [data],
          },
        ],
      });
    },
  },
};
</script>
<style scoped>
#main {
  height: 480px;
}
</style>
